import React, { useState, useEffect } from 'react'
import { getCurrentDate } from '../../Utils/Dateutils';
import styled, { cutDates, inputStyles, stockNumber } from '../../Utils/inputChanges';
import { styled as muiStyled } from '@mui/material/styles';


import {
  TextField, FormControl, InputLabel, Grid, Paper,
  useMediaQuery, Button, FormHelperText, Table, TableBody, TableHead, TableCell, TableContainer, Typography,
  TableRow, Autocomplete, TextareaAutosize, Checkbox
} from '@mui/material';
import TitleBar from '../TitleBar';
import { ReceiptMenu } from '../TitleList';
import DateInputComponent from '../FieldsComponents/DateInputComponent';
import Dropdown from '../FieldsComponents/Dropdown';
import RadioComponent from '../FieldsComponents/RadioComponent';
import TextareaComponent from '../FieldsComponents/TextareaComponent';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCompanyData } from '../../Store/PHPSlice/Firm';
import { selectFirm, selectParty } from '../Selectors/Master/ItemSelectors';
import { fetchPartyData } from '../../Store/PHPSlice/Party';
import axios from 'axios';
import { insertSettlementEntry, fetchSettlementNo, fetchTotAdvAmt, fetchSettlementDetails, fetchInvoiceDetails, selectSettlementDetails, selectInvoiceDetails } from '../../Store/PHPSlice/ReceiptApi/receiptApi';

const StyledTableCell = muiStyled(TableCell)(({ theme }) => ({
  border: '1px solid #cfcfcf',
  fontSize: '13px',
  padding: '6px 8px',
}));
const StyledInvoiceHeadCell = muiStyled(StyledTableCell)(() => ({
  backgroundColor: '#2e7d32', // MUI green[800]
  color: '#ffffff',
  fontWeight: 600,
}));
const StyledTableHeadCell = muiStyled(StyledTableCell)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.common.white,
  fontWeight: 600,
}));

const StyledTableRow = muiStyled(TableRow)(() => ({
  '&:nth-of-type(even)': {
    backgroundColor: '#fafafa',
  },
}));

const SettlementEntry = () => {
  const [settlementList, setSettlementList] = useState([]);
  const [billList, setBillList] = useState([]);
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const userdata = JSON.parse(localStorage.getItem('user'));
  const [formData, setFormData] = useState({
    dt: getCurrentDate(),
    firmId: '',
    empId: '',
    rptNo: '',
    billNo: '',
    partyId: '',
    receiptType: '',
    total: '0',
    totPaid: '0',
    netBal: '0',
    narr: '',
    payM: 'cash',
    payAmt: '',
    balAmt: '',
    bnkNm: '',
    chqNo: '',
    chqdt: '',
    trnsId: '',
    payType: '',
    userId: userdata?.ID
  });

  const dispatch = useDispatch();
  const firmList = useSelector(selectFirm);
  const partyList = useSelector(selectParty);
  const receiptNoFromStore = useSelector(
    state => state.ReceiptDatalist?.settlementNo || ''
  );
  const totAdvAmt = useSelector(
    state => state.ReceiptDatalist?.totAdvAmt || 0
  );
  const settlementDetails = useSelector(selectSettlementDetails);
  const invoiceDetails = useSelector(selectInvoiceDetails);
  const [selectedSettlements, setSelectedSettlements] = useState([]);
  const [selectedInvoices, setSelectedInvoices] = useState([]);
  //console.log("rptno=>", receiptNoFromStore);
  useEffect(() => {
    dispatch(fetchCompanyData());
    dispatch(fetchPartyData());
  }, [dispatch]);
  useEffect(() => {
    if (formData.receiptType !== 'bill') {
      setFormData(prev => ({
        ...prev,
        billNo: '',
        totbill: '0',
        netBal: '0',
        totPaid: '0',
      }));
    }
  }, [formData.receiptType]);
  useEffect(() => {
    setFormData(prev => ({
      ...prev,
      rptNo: receiptNoFromStore || ''
    }));
  }, [receiptNoFromStore]);
  useEffect(() => {
    setFormData(prev => ({
      ...prev,
      total: totAdvAmt || 0
    }));
  }, [totAdvAmt]);

  useEffect(() => {
    const settlementTotal = settlementDetails
      ?.filter(row => selectedSettlements.includes(String(row.Id)))
      .reduce((sum, row) => sum + Number(row.amt || 0), 0);

    const invoicePaidTotal = invoiceDetails
      ?.filter(row => selectedInvoices.includes(String(row.Id)))
      .reduce((sum, row) => sum + Number(row.balAmt || 0), 0);

    const remaining = settlementTotal - invoicePaidTotal;

    setFormData(prev => ({
      ...prev,
      total: settlementTotal,
      totPaid: invoicePaidTotal,
      totbill: remaining
    }));
  }, [selectedSettlements, selectedInvoices, settlementDetails, invoiceDetails]);



  const fields = [
    { label: 'Date', name: 'dt', type: 'date' }
  ];


  const isDesktop = useMediaQuery('(min-width:768px)');
  const handleDateChange = (e) => {
    setFormData({
      ...formData,
      dt: e.target.value
    });
  };
  const handleSettlementCheck = (id) => {
    setSelectedSettlements(prev =>
      prev.includes(String(id))
        ? prev.filter(item => item !== String(id))
        : [...prev, String(id)]
    );
  };

  const handleInvoiceCheck = (id) => {
    setSelectedInvoices(prev =>
      prev.includes(String(id))
        ? prev.filter(item => item !== String(id))
        : [...prev, String(id)]
    );
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    // If the field is 'payAmt', ensure it's not greater than totbill
    if (name === "payAmt") {
      const numericValue = Number(value);
      const maxAllowed = Number(formData.totbill);
      if (!maxAllowed) {
        setFormData(prev => ({
          ...prev,
          payAmt: numericValue,
          balAmt: 0
        }));
        return;
      }

      // Limit payAmt to totbill
      if (numericValue > maxAllowed) {
        return; // Do nothing if exceeds total bill
      }

      const balamt = maxAllowed - numericValue;

      setFormData(prev => ({
        ...prev,
        payAmt: numericValue,
        balAmt: maxAllowed - numericValue
      }));
    } else {
      setFormData({
        ...formData,
        [name]: value
      });
    }
  };
  const receiptTypeDropdown = [
    {
      label: 'Settlement Type',
      id: 'receiptType',
      options: [
        { ID: 'Adv', label: 'Advance Settlement' },
        { ID: 'Rt', label: 'Return Goods Settlement' }

      ],
      value: formData.receiptType,
      onChange: (newValue) =>
        handleDropdownChange(
          { target: { value: newValue ? newValue.ID : '' } },
          'receiptType'
        ),
      getOptionLabel: (option) => option?.label || '',
      isOptionEqualToValue: (option, value) => option.ID === value.ID,
      valueFinder: (options, value) =>
        options.find(item => item.ID === value) || null
    }
  ];



  const dropdownlistfirst = [
    {
      label: 'Firm Name',
      id: 'firmId',
      options: firmList?.data || [],
      value: formData.firmId,
      onChange: (newValue) => handleDropdownChange({ target: { name: 'firmId', value: newValue ? newValue.ID : '' } }, 'firmId'),
      getOptionLabel: (option) => option.firmNm || '',
      isOptionEqualToValue: (option, value) => option.ID === value.ID,
      valueFinder: (options, value) => {
        if (Array.isArray(options)) {
          return options.find(item => item.ID === value) || null;
        }
        return null;
      },
    },
    {
      label: 'Party',
      id: 'partyId',
      options: partyList?.data || [],
      value: formData.partyId,
      onChange: (newValue) => handleDropdownChange({ target: { name: 'partyId', value: newValue ? newValue.ID : '' } }, 'partyId'),
      getOptionLabel: (option) => option.partyNm || '',
      isOptionEqualToValue: (option, value) => option.ID === value.ID,
      valueFinder: (options, value) => {
        if (Array.isArray(options)) {
          return options.find(item => item.ID === value) || null;
        }
        return null;
      }
    },

    // {
    //     label: 'Bill No.',
    //     id: 'billNo',
    //     options: billList || [],
    //     value: formData.billNo,
    //     onChange: (newValue) => handleDropdownChange({ target: { name: 'billNo', value: newValue ? newValue.ID : '' } }, 'billNo'),
    //     getOptionLabel: (option) => option.billNo || '',
    //     isOptionEqualToValue: (option, value) => option.ID === value.ID,
    //     valueFinder: (options, value) => {
    //         if (Array.isArray(options)) {
    //             return options.find(item => item.ID === value) || null;
    //         }
    //         return null;
    //     },
    // },

  ];
  // console.log(billList)


  const dropdownlistsecond = [
    {
      label: 'Bill No.',
      id: 'billNo',
      options: billList || [],
      value: formData.billNo,
      onChange: (newValue) => handleDropdownChange({ target: { name: 'billNo', value: newValue ? newValue.ID : '' } }, 'billNo'),
      getOptionLabel: (option) => option.billNo || '',
      isOptionEqualToValue: (option, value) => option.ID === value.ID,
      valueFinder: (options, value) => {
        if (Array.isArray(options)) {
          return options.find(item => item.ID === value) || null;
        }
        return null;
      },
    },
  ];

  // const handleDropdownChange = async (e, dropdownType) => {
  //     const { value } = e.target;
  //     setFormData({
  //         ...formData,
  //         [dropdownType]: value
  //     });

  //     switch (dropdownType) {

  //         case 'partyId':
  //             if (value && formData.firmId !== '') {
  //                 const data = {
  //                     firmId: formData.firmId,
  //                     partyId: value,
  //                     receiptType: formData.receiptType
  //                 };
  //                dispatch( fetchTotAdvAmt(data));
  //             }
  //             break;
  //         case 'firmId':
  //             if (value && formData.partyId !== '') {
  //                 const data = {
  //                     firmId: value,
  //                     partyId: formData.partyId,
  //                     receiptType: formData.receiptType
  //                 };
  //                 dispatch(fetchTotAdvAmt(data));
  //             }
  //             break;


  //         case 'receiptType':
  //             window.requestAnimationFrame(() => {
  //                 setFormData(prev => ({
  //                     ...prev,
  //                     receiptType: value,
  //                     billNo: '',
  //                     totbill: '0',
  //                     payAmt: '',
  //                     balAmt: ''
  //                 }));
  //             });

  //             setBillList([]);

  //             // ✅ Fetch receipt no
  //             dispatch(fetchSettlementNo({ receiptType: value }));

  //             // ✅ FETCH BILL NOS WHEN RECEIPT TYPE IS BILL


  //                 dispatch( fetchTotAdvAmt({

  //                     firmId: formData.firmId,
  //                     partyId: formData.partyId,
  //                     receiptType: value
  //                 }));


  //             break;

  //         default:
  //             break;
  //     };
  // };
  const handleDropdownChange = (e, dropdownType) => {
    const { value } = e.target;

    setFormData(prev => ({
      ...prev,
      [dropdownType]: value
    }));

    if (
      (dropdownType === 'partyId' || dropdownType === 'firmId' || dropdownType === 'receiptType') &&
      formData.firmId &&
      formData.partyId &&
      value
    ) {
      dispatch(fetchTotAdvAmt({
        firmId: dropdownType === 'firmId' ? value : formData.firmId,
        partyId: dropdownType === 'partyId' ? value : formData.partyId,
        receiptType:
          dropdownType === 'receiptType' ? value : formData.receiptType
      }));
      dispatch(fetchSettlementDetails({
        firmId: dropdownType === 'firmId' ? value : formData.firmId,
        partyId: dropdownType === 'partyId' ? value : formData.partyId,
        receiptType:
          dropdownType === 'receiptType' ? value : formData.receiptType
      }));
      dispatch(fetchInvoiceDetails({
        firmId: dropdownType === 'firmId' ? value : formData.firmId,
        partyId: dropdownType === 'partyId' ? value : formData.partyId,
        receiptType:
          dropdownType === 'receiptType' ? value : formData.receiptType
      }));
    }

    if (dropdownType === 'receiptType') {
      dispatch(fetchSettlementNo({ receiptType: value }));
    }
  };

  // const fields01 = [
  //     { label: 'Settlement No.', name: 'rptNo', type: 'readOnly' },
  //     { label: 'Total Amt', name: 'total', type: 'readOnly', sx: { color: 'blue',fontWeight: 700, fontSize: '18px'} },
  //     // { label: 'Total Paid Amt', name: 'totPaid', type: 'readOnly' },
  //     // { label: 'Net Balance', name: 'netBal', type: 'readOnly' }
  // ];

  // const fields02 = [

  //     { label: 'Total Paid Amt', name: 'totPaid', type: 'readOnly', sx: { color: 'green',fontWeight: 'bold', fontSize: '180px'}  },
  //      { label: 'Total Remain Amt', name: 'totbill', type: 'readOnly', sx: { color: '#ff0000',fontWeight: 'bold', fontSize: '180px'}  }
  // ];

  const fields01 = [
    {
      label: 'Settlement No.',
      name: 'rptNo',
      type: 'readOnly'
    },
    {
      label: 'Total Amt',
      name: 'total',
      type: 'readOnly',
      sx: {
        color: 'blue',
        fontWeight: 'bold',
        fontSize: '18px'
      }
    }
  ];

  const fields02 = [
    {
      label: 'Total Paid Amt',
      name: 'totPaid',
      type: 'readOnly',
      sx: {
        color: 'green',
        fontWeight: 'bold',
        fontSize: '18px'
      }
    },
    {
      label: 'Total Remain Amt',
      name: 'totbill',
      type: 'readOnly',
      sx: {
        color: '#ff0000',
        fontWeight: 'bold',
        fontSize: '18px'
      }
    }
  ];



  const tableContainerStyle = {
    marginTop: '1%',
    overflow: 'hidden',
    scrollbarWidth: 'none',
    msOverflowStyle: 'none',
  };
  const webkitScrollbarStyle = {
    overflowX: 'auto',
    overflowY: 'hidden',
    WebkitOverflowScrolling: 'touch',
  };

  const handleCheckboxChange = (index) => {
    const updatedList = [...settlementDetails];
    updatedList[index].checked = !updatedList[index].checked;
    setSettlementList(updatedList);
  };


  const fetchSaleInvBillNos = async (id) => {
    //        console.log("API called with:", id);

    const { firmId, partyId, billNo } = id;
    try {
      const response = await axios.get(`${baseUrl}?apicall=getSaleInvBillNos&firmId=${firmId}&partyId=${partyId}&billNo=${billNo}`);
      //  console.log("billapiresponse=>", response.data);
      const billNos = response?.data?.data;
      setBillList(billNos);

    } catch (error) {
      console.error('Error fetching info list:', error);
    }
  };
  const fetchSaleInvBillNoData = async ({ firmId, partyId, billNo }) => {
    //   console.log("API called with:", firmId, partyId, billNo);

    try {
      const res = await axios.get(
        `${baseUrl}?apicall=fetchsaleinvbillnodata&firmId=${firmId}&partyId=${partyId}&billNo=${billNo}`
      );

      const data = res?.data?.data || {};

      // console.log("API response:", data);

      const netamt = Number(data.netamt || 0);
      const paidamt = Number(data.paidamt || 0);
      const balance = netamt - paidamt;

      setFormData(prev => ({
        ...prev,
        total: netamt,
        totPaid: paidamt,
        totbill: balance,
        netBal: balance
      }));

    } catch (err) {
      console.error("API error:", err);
    }
  };
  const fetchBillAdvData = async ({ firmId, partyId, receiptType }) => {
    //   console.log("API called with:", firmId, partyId, billNo);

    try {
      const res = await axios.get(
        `${baseUrl}?apicall=getRcptData&firmId=${firmId}&partyId=${partyId}&receiptType=${receiptType}`
      );

      const data = res?.data?.data || {};

      console.log("API response:", data);


      const paidamt = Number(data.amt || 0);


      setFormData(prev => ({
        ...prev,
        total: paidamt

      }));

    } catch (err) {
      console.error("API error:", err);
    }
  };

  function postObj(formData) {
    return {
      dt: formData.dt,
      firmId: formData.firmId,
      partyId: formData.partyId,
      receiptNo: formData.rptNo,
      receiptType: formData.receiptType,

      // ✅ calculated totals
      total_amt: formData.total,
      paid_amt: formData.totPaid,
      remaining_amt: formData.totbill,

      // ✅ selected IDs (MOST IMPORTANT)
      settlement_ids: selectedSettlements, // array
      invoice_ids: selectedInvoices,       // array

      narr: formData.narr,
      userId: formData.userId
    };
  }


  const handleSubmit = (e) => {
    e.preventDefault();

    const finaldata = postObj(formData);
    //  console.log(finaldata);
    dispatch(insertSettlementEntry(finaldata))
      .unwrap()
      .then((result) => {
        if (result?.msg) {
          alert(result.msg);
        } else {
          alert("Unknown response from server");
        }
        window.location.reload();
      })
      .catch((error) => {
        // Handle error
        console.error('Error while making POST request:', error);
        // You may want to display an error message to the user or perform any other action
      });

  };

  return (
    <>
      <TitleBar data={ReceiptMenu} />
      <div style={{ margin: '1% 0.5%' }}>
        <h2> Settlement Entry</h2>

        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Paper style={{ padding: '2vh' }}>
              <Grid container spacing={0.5}>

                {fields?.map((field) => (
                  <DateInputComponent
                    key={field.name}
                    formData={formData}
                    handleDateChange={handleDateChange}
                    handleInputChange={handleInputChange}
                    styled={styled}
                    inputStyles={inputStyles}
                    isDesktop={isDesktop}
                    field={field}
                  />
                ))}


                {
                  dropdownlistfirst && dropdownlistfirst?.map((drop) => (
                    <Dropdown
                      key={drop.label}
                      label={drop.label}
                      id={drop.id}
                      options={drop.options}
                      value={drop.value}
                      onChange={drop.onChange}
                      isDesktop={isDesktop}
                      getOptionLabel={drop.getOptionLabel}
                      isOptionEqualToValue={drop.isOptionEqualToValue}
                      valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                    />
                  ))
                }
                {
                  receiptTypeDropdown?.map((drop) => (
                    <Dropdown
                      key={drop.id}
                      label={drop.label}
                      id={drop.id}
                      options={drop.options}
                      value={drop.value}
                      onChange={drop.onChange}
                      isDesktop={isDesktop}
                      getOptionLabel={drop.getOptionLabel}
                      isOptionEqualToValue={drop.isOptionEqualToValue}
                      valueFinder={drop.valueFinder}
                    />
                  ))
                }



                {fields01?.map((field) => (
                  <DateInputComponent
                    key={field.name}
                    formData={formData}
                    handleDateChange={handleDateChange}
                    handleInputChange={handleInputChange}
                    styled={styled}
                    inputStyles={inputStyles}
                    isDesktop={isDesktop}
                    field={field}
                  />
                ))}



                {
                  fields02?.map((field) => (
                    <DateInputComponent
                      key={field.name}
                      formData={formData}
                      handleDateChange={handleDateChange}
                      handleInputChange={handleInputChange}
                      styled={styled}
                      inputStyles={inputStyles}
                      isDesktop={isDesktop}
                      field={field}
                    />
                  ))
                }







                <TextareaComponent
                  label="Naration"
                  name="narr"
                  value={formData.narr}
                  onChange={handleInputChange}
                  isDesktop={isDesktop}
                />



                {/* TABLES SECTION */}
                <Grid item xs={12}>
                  <Grid container spacing={2} sx={{ mt: 2 }}>

                    {/* ADVANCE DETAILS TABLE */}
                    <Grid item xs={12} md={6}>
                      <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 1 }}>
                        {formData.receiptType === 'Adv'
                          ? 'Advance Settlement Details'
                          : formData.receiptType === 'Rt'
                            ? 'Return Goods Settlement Details'
                            : 'Settlement Details'}
                      </Typography>

                      <TableContainer component={Paper} variant="outlined">
                        <Table size="small">
                          <TableHead>
                            <TableRow>
                              <StyledTableHeadCell>Sr No</StyledTableHeadCell>
                              <StyledTableHeadCell>Advance No</StyledTableHeadCell>
                              <StyledTableHeadCell>Date</StyledTableHeadCell>
                              <StyledTableHeadCell align="right">Amount</StyledTableHeadCell>
                            </TableRow>
                          </TableHead>

                          <TableBody>
                            {settlementDetails?.length > 0 ? (
                              settlementDetails.map((row, index) => (
                                <StyledTableRow key={row.Id} hover>
                                  <StyledTableCell> <Checkbox
                                    size="small"
                                    checked={selectedSettlements.includes(row.Id)}
                                    onChange={() => handleSettlementCheck(row.Id)}
                                  /><span style={{ color: 'black', fontWeight: 'bold' }}>{index + 1}</span></StyledTableCell>
                                  <StyledTableCell><span style={{ color: 'black', fontWeight: 'bold' }}>{row.rcptNo}</span></StyledTableCell>
                                  <StyledTableCell><span style={{ color: 'black', fontWeight: 'bold' }}>{row.dt}</span></StyledTableCell>
                                  <StyledTableCell align="right"><span style={{ color: 'green', fontWeight: 'bold' }}>{row.amt}</span></StyledTableCell>
                                </StyledTableRow>
                              ))
                            ) : (
                              <StyledTableRow>
                                <StyledTableCell colSpan={4} align="center">
                                  No Advance Records
                                </StyledTableCell>
                              </StyledTableRow>
                            )}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Grid>


                    {/* INVOICE DETAILS TABLE */}
                    <Grid item xs={12} md={6}>
                      <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 1 }}>
                        Invoice Details
                      </Typography>

                      <TableContainer component={Paper} variant="outlined">
                        <Table size="small">
                          <TableHead>
                            <TableRow>
                              <StyledInvoiceHeadCell>Sr No</StyledInvoiceHeadCell>
                              <StyledInvoiceHeadCell>Date</StyledInvoiceHeadCell>

                              <StyledInvoiceHeadCell>Invoice No</StyledInvoiceHeadCell>
                              <StyledInvoiceHeadCell align="right">Total Amt</StyledInvoiceHeadCell>
                              <StyledInvoiceHeadCell align="right">Total Rcpt Paid Amt</StyledInvoiceHeadCell>
                              <StyledInvoiceHeadCell align="right">Balance</StyledInvoiceHeadCell>
                            </TableRow>
                          </TableHead>

                          <TableBody>
                            {invoiceDetails?.length > 0 ? (
                              invoiceDetails.map((row, index) => (
                                <StyledTableRow key={row.Id} hover>
                                  <StyledTableCell> <Checkbox
                                    size="small"
                                    checked={selectedInvoices.includes(row.Id)}
                                    onChange={() => handleInvoiceCheck(row.Id)}
                                  /><span style={{ color: 'black', fontWeight: 'bold' }}>{index + 1}</span></StyledTableCell>
                                  <StyledTableCell><span style={{ color: 'black', fontWeight: 'bold' }}>{row.dt}</span></StyledTableCell>
                                  <StyledTableCell><span style={{ color: 'black', fontWeight: 'bold' }}>{row.billNo}</span></StyledTableCell>
                                  <StyledTableCell align="right"><span style={{ color: 'blue', fontWeight: 'bold' }}>{row.net_amt}</span></StyledTableCell>
                                  <StyledTableCell align="right"><span style={{ color: 'green', fontWeight: 'bold' }}>{row.rcptPaid}</span></StyledTableCell>
                                  <StyledTableCell align="right"><span style={{ color: 'red', fontWeight: 'bold' }}>{row.balAmt}</span></StyledTableCell>
                                </StyledTableRow>
                              ))
                            ) : (
                              <StyledTableRow>
                                <StyledTableCell colSpan={5} align="center">
                                  No Invoice Records
                                </StyledTableCell>
                              </StyledTableRow>
                            )}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Grid>


                  </Grid>
                </Grid>


                <Grid item xs={12} textAlign="center">
                  <Button variant="contained" color="primary" onClick={handleSubmit} >Submit</Button>
                </Grid>

              </Grid>

            </Paper>
          </Grid>

        </Grid>

      </div>
    </>
  )
}

export default SettlementEntry;
